import { render, staticRenderFns } from "./bearish_harami_cross.vue?vue&type=template&id=dec8f7d2"
import script from "./bearish_harami_cross.vue?vue&type=script&lang=js"
export * from "./bearish_harami_cross.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports